import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from '../../contexts/UserContext'
import Dashboard from '../Dashboard/Dashboard'
import Overview from '../Overview/Overview'
import { Spinner } from 'flowbite-react'
import PrivateLayout from '../../layouts/PrivateLayout/PrivateLayout'

const Home = () => {
    const { userDetails } = useContext(UserContext) ?? {}
    
    const [loading, setLoading ] = useState(true)
    const [status, setStatus] = useState<string>("")
    const [businessName, setBusinessName] = useState<string>("")
    useEffect(() => {
        
        if (userDetails?.activeSubsidiary) {
            const { activeSubsidiary } = userDetails;            
            setStatus(activeSubsidiary.status)
            setBusinessName(activeSubsidiary.businessName)
            setLoading(false);
        }
    }, [userDetails]);
  return (
    <PrivateLayout>
    <div>
        {loading ? <Spinner/> : (
            status == "Pending-Approval" || status == "Active" ? <Dashboard businessName={businessName}/> :<Overview/>
        )}
    </div>
    </PrivateLayout>
  )
}

export default Home
